import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import { useGlobalState } from "../../../contexts/GlobalContext";
import {
  fetchUserInfoProxy,
  fetchUpdateUserMeataData,
  upsertAccountAndSyncSF,
} from "../../../utils/helpers/api";
import { useNotificationTimestamp } from "../../../hooks/features/notification/useNotificationTimestamp";
import { Http, Routes } from "../../../utils/constants";
import { AxiosResponse } from "axios";

import BasicInfo from "./BasicInfo";
import NewsletterSetting from "./NewsletterSetting";
import BasicInterests from "./BasicInterests";
import WorkPlace from "./WorkPlace";
import {
  businessAndManagementJobs,
  componentMapping,
  creativeAndDesignJobs,
  environmentAndInfrastructureJobs,
  generalOrganizationAndSkillsKnowledge,
  generalSocialTrendsCode,
  generalWorkAndLifePlanning,
  informationAndTechnologyJobs1,
  informationAndTechnologyJobs2,
  occupationSelect,
  other,
  mappingNewUser,
  mappingUser,
  PERSON_TITLE,
  positions,
  workAddressSelect,
  environmentalManagementJobs,
  carbonNeutralJobs,
  solarPowerJobs,
  energyBusinessJobs,
  energySavingEquipmentJobs,
  circularEconomyJobs,
  chemicalAndPollutionJobs,
  otherEnvironmentalJobs,
} from "../../../utils/constants/constant";
import HomePlace from "./HomePlace";
import { getLabelsFromIds, needsExternalSession } from "../../../utils/helpers/string";
import {
  attachBulkDownloadIfNeeded,
  isAdverTimesBulkDownloadFlow,
  persistBulkDownloadFlag,
} from "../../../utils/helpers/function";
import { appConfig } from "../../../utils/configs";

interface IStateLocation {
  data: IUserMetaDataApi;
  isFirstTimeSetting: boolean;
  survey?: boolean;
  survey_id?: string;
  surveyMember?: boolean;
  webLinkId?: string;
}
const UserSettingConfirm: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { setStateValue, globalState, setGlobalState, refreshAccessToken, createExternalSession } = useGlobalState();
  const { addTimestamp } = useNotificationTimestamp();
  const { data, isFirstTimeSetting, survey, survey_id,surveyMember,webLinkId } = (location.state as IStateLocation) ?? {};
  const { user } = globalState;
  const user_id = user?.user_id;
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get("serviceid");
  const returnTo =
    searchParams.get("returnto") ||
    localStorage.getItem("settingCallBackUrl") ||
    localStorage.getItem("loginCallBackUrl");
  const sessionId = searchParams.get("session_id");
  const serviceIdNumber = serviceId ? Number(serviceId) : 0;
  const user_status = data?.user_status;
  const selectedComponents = (serviceId &&
    componentMapping[serviceIdNumber]) || (user_status === 1 || user_status === 3 ? mappingNewUser : mappingUser);
    const [state, setState] = useState<ISettingConfirmState>({
    accountSF: {},
    dataSyncCustomeSf: {},
  });

  const { accountSF, dataSyncCustomeSf } = state;
  const [isSurvey, setIsSurvey] = useState<boolean>(false);

  useEffect(() => {
    persistBulkDownloadFlag(searchParams.get("bulkDownload") === "true");
  }, [searchParams]);

  useEffect(() => {
    if (!location.state?.data) {
      navigate(Routes.USERSETTING);
    }
  }, [location, navigate]);

  useEffect(() => {
    setStateValue("isShowMenu", !isFirstTimeSetting);
  }, [isFirstTimeSetting]);

  useEffect(() => {
    document.title =
      "宣伝会議 : アカウント管理 | お客様情報の登録・変更（確認）";
    localStorage.removeItem("isUserSetting");
  }, []);

  const SDKG_InterestingThemes = [
    ...generalSocialTrendsCode,
    ...generalOrganizationAndSkillsKnowledge,
    ...generalWorkAndLifePlanning,
  ];
  SDKG_InterestingThemes.push({ label: "当てはまるものはない", value: "0" });

  const SDKG_EnvironmentalThemes = [
    ...environmentalManagementJobs,
    ...carbonNeutralJobs,
    ...solarPowerJobs,
    ...energyBusinessJobs,
    ...energySavingEquipmentJobs,
    ...circularEconomyJobs,
    ...chemicalAndPollutionJobs,
    ...otherEnvironmentalJobs,
  ]

  const SDKG_NewDepartment = [
    ...businessAndManagementJobs,
    ...creativeAndDesignJobs,
    ...environmentAndInfrastructureJobs,
    ...informationAndTechnologyJobs1,
    ...informationAndTechnologyJobs2,
    ...other,
  ];

  const SDKG_JobChangeInformation = [
    { label: "ある", value: "0" },
    { label: "なし", value: "1" },
  ];

  useEffect(() => {
    if (data) {
      const getLabelFromValue = (value: string) => {
        const found = PERSON_TITLE.find((item) =>
          item?.values?.includes(value)
        );
        return found ? found.label : null;
      };

      setState((prevState) => ({
        ...prevState,
        accountSF: {
          SsoID__pc: user?.user_metadata.customUserId, // customer id
          LastName: data.profile?.fullName?.lastName, // profile.fullname.lastname
          FirstName: data.profile?.fullName?.firstName, // profile.fullname.FirstName
          Company__pc: data.workPlaceInfo?.companyName, // workplace.companyname
          PersonEmail: user?.email,
          SDKG_NewJobLayer__pc:
            positions.find(
              (item) =>
                item.value == data?.workPlaceInfo?.positionCode?.toString()
            )?.label ?? "",
          ContactInformation__pc:
            data.profile?.contactType === 1 ? "自宅" : "勤務先",
          NameKana__pc: `${data?.profile?.fullNameKana?.lastName} ${data?.profile?.fullNameKana?.firstName}`, //profile.fullnameKana.FirstName + profile.fullnameKana.last name
          lbc_office_id__pc: data.workPlaceInfo?.lbcCode ?? "", // lbccode
          DepartmentName__pc: data.workPlaceInfo?.departmentName ?? "", // workplace.DepartmentName
          AddressType__pc: data.profile?.contactType === 1 ? "自宅" : "勤務先", // profile.contactType
          PersonMailingPostalCode:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.postalCode?.toString()
              : data.profile?.address?.postalCode?.toString(), // profile.address.PostalCode
          PersonMailingState:
            data.profile?.contactType !== 1
              ? workAddressSelect.find(
                  (item) =>
                    item.value ===
                    data?.workPlaceInfo?.prefectureCode?.toString()
                )?.label ?? ""
              : workAddressSelect.find(
                  (item) =>
                    item.value ===
                    data?.profile?.address?.prefectureCode?.toString()
                )?.label ?? " ", // profile.address.prefectureCode
          PersonMailingCity:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.city
              : data.profile?.address?.city, // profile.address.City
          PersonMailingStreet:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.line
              : data.profile?.address?.line ?? "", // profile.address.line
          CompanyTel__pc: data.workPlaceInfo?.phoneNumber ?? "", // workplace.phonenumber
          CompanyMobilePhone__pc: data.workPlaceInfo?.mobilePhoneNumber ?? "", // workplace.mobilePhoneNumber
          PersonHomePhone: data.profile?.phoneNumber ?? "", // profile.phonenumber
          CompanyFax__pc: data.workPlaceInfo?.faxNumber ?? "", // workplace.CompanyFax
          Sex__pc: data.profile?.genderCode?.toString() ?? "0", // profile.genderCode
          TransitionSource__pc: user?.user_metadata.transition_source ?? "", // transition_source
          JobLayer__pc:
            getLabelFromValue(data.workPlaceInfo?.positionCode ?? "") ?? "", // workPlaceInfo.positionCode
          Newsletter1__pc: data.newsletterSubscription?.editorialBooks ?? false, // newsletterSubscription.editorialBooks
          Newsletter3__pc: data.newsletterSubscription?.editorialBrain ?? false, // newsletterSubscription.editorialBrain
          Newsletter5__pc:
            data.newsletterSubscription?.editorialHansokukaigi ?? false, // newsletterSubscription.editorialHansokukaigi
          Newsletter6__pc: data.newsletterSubscription?.advertimes ?? false, // newsletterSubscription.advertimes
          Newsletter7__pc:
            data.newsletterSubscription?.editorialKohokaigi ?? false, // newsletterSubscription.editorialKohokaigi
          Newsletter8__pc: data.newsletterSubscription?.contestsAwards ?? false, // newsletterSubscription.contestsAwards
          Newsletter9__pc:
            data.newsletterSubscription?.editorialSendenkaigi ?? false, // newsletterSubscription.editorialSendenkaigi
          Newsletter24__pc: data.newsletterSubscription?.classInfo ?? false, // newsletterSubscription.classInfo
          Newsletter11__pc:
            data.newsletterSubscription?.digitalMagazine ?? false, // newsletterSubscription.digitalMagazine
          Newsletter25__pc:
            data.newsletterSubscription?.adPlacementSponsorship ?? false, // newsletterSubscription.adPlacementSponsorship
          Newsletter18__pc:
            data.newsletterSubscription?.environmentalBusinessOnline ?? false, // newsletterSubscription.environmentalBusinessOnline
          Newsletter21__pc:
            data.newsletterSubscription?.environmentalBusinessOnlineNews ?? false,
          Newsletter10__pc:
            data.newsletterSubscription?.sendenkaigiInfo ?? false, // newsletterSubscription.sendenkaigiInfo
          Newsletter26__pc:
            data.newsletterSubscription?.jobChangeInfo ?? false, // newsletterSubscription.jobChangeInfo
        },
        dataSyncCustomeSf: {
          SsoID__c: user?.user_metadata.customUserId.toString(),
          LastName: data.profile?.fullName?.lastName,
          FirstName: data.profile?.fullName?.firstName,
          NameKana__pc: `${data?.profile?.fullNameKana?.lastName} ${data?.profile?.fullNameKana?.firstName}`,
          Company__pc: data.workPlaceInfo?.companyName,
          PersonDepartment: data.workPlaceInfo?.departmentName,
          SDKG_NewJobLayer__pc:
            positions.find(
              (item) =>
                item.value == data?.workPlaceInfo?.positionCode?.toString()
            )?.label ?? "",
          ContactInformation__pc:
            data.profile?.contactType !== 1 ? "勤務先" : "自宅",
          SDKG_PriorityContacts__pc:
            data.profile?.contactType !== 1 ? "勤務先" : "自宅",
          AddressType__pc: data.profile?.contactType === 1 ? "自宅" : "勤務先",
          PersonMailingPostalCode:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.postalCode?.toString()
              : data.profile?.address?.postalCode?.toString(),
          PersonMailingState:
            data.profile?.contactType !== 1
              ? workAddressSelect.find(
                  (item) =>
                    item.value ===
                    data?.workPlaceInfo?.prefectureCode?.toString()
                )?.label ?? ""
              : workAddressSelect.find(
                  (item) =>
                    item.value ===
                    data?.profile?.address?.prefectureCode?.toString()
                )?.label ?? "",
          PersonMailingCity:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.city
              : data.profile?.address?.city,
          PersonMailingStreet:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.line
              : data.profile?.address?.line ?? "",
          CompanyTel__pc: data.workPlaceInfo?.phoneNumber ?? "",
          CompanyMobilePhone__pc: data.workPlaceInfo?.mobilePhoneNumber ?? "",
          PersonHomePhone: data.profile?.phoneNumber ?? "",
          PersonMobilePhone: data.profile?.mobilePhoneNumber ?? "",
          CompanyFax__pc: data.workPlaceInfo?.faxNumber ?? "",
          PersonEmail: user?.email,
          Sex__pc: data.profile?.genderCode?.toString() ?? "0",
          TransitionSource__pc: user?.user_metadata.transition_source ?? "", // transition_source
          PersonBirthdate: `${data?.profile?.birth?.year}/${data?.profile?.birth?.month}/${data?.profile?.birth?.day}`,
          JobLayer__pc:
            getLabelFromValue(data.workPlaceInfo?.positionCode ?? "") ?? "",
          lbc_office_id__pc: data.workPlaceInfo?.lbcCode ?? "",
          Newsletter1__pc: data.newsletterSubscription?.editorialBooks ?? false,
          Newsletter3__pc: data.newsletterSubscription?.editorialBrain ?? false,
          Newsletter5__pc:
            data.newsletterSubscription?.editorialHansokukaigi ?? false,
          Newsletter6__pc: data.newsletterSubscription?.advertimes ?? false,
          Newsletter7__pc:
            data.newsletterSubscription?.editorialKohokaigi ?? false,
          Newsletter8__pc: data.newsletterSubscription?.contestsAwards ?? false,
          Newsletter9__pc:
            data.newsletterSubscription?.editorialSendenkaigi ?? false,
          Newsletter24__pc: data.newsletterSubscription?.classInfo ?? false,
          Newsletter11__pc:
            data.newsletterSubscription?.digitalMagazine ?? false,
          Newsletter25__pc:
            data.newsletterSubscription?.adPlacementSponsorship ?? false,
          Newsletter18__pc:
            data.newsletterSubscription?.environmentalBusinessOnline ?? false,
          Newsletter21__pc:
            data.newsletterSubscription?.environmentalBusinessOnlineNews ?? false,
          Newsletter10__pc:
            data.newsletterSubscription?.sendenkaigiInfo ?? false,
          Newsletter26__pc:
            data.newsletterSubscription?.jobChangeInfo ?? false,
          SDKG_InterestingThemes__pc: getLabelsFromIds(
            SDKG_InterestingThemes,
            data?.interest?.jobCodes ?? []
          ),
          SDKG_NewDepartment__pc: getLabelsFromIds(
            SDKG_NewDepartment,
            data.workPlaceInfo?.affiliationCodes ?? []
          ),
          SDKG_Occupation__pc: occupationSelect.find(
            (item) => item.value === data?.profile?.occupationCode?.toString()
          )?.label,
          SDKG_EnvironmentalThemes__pc: getLabelsFromIds(
            SDKG_EnvironmentalThemes,
            data?.interest?.environmentBusinessCodes ?? []
          ),
          SDKG_JobChangeInformation__pc: SDKG_JobChangeInformation.find(
            (item) => item.value === data?.interest?.jobChangeCode?.toString()
          )?.label ?? "",
        },
      }));
    }
  }, [data]);

  const handleScrollToTop = () => {
    document.documentElement.style.scrollBehavior = "auto";
    setTimeout(() => window.scrollTo(0, 0), 5);
    setTimeout(
      () => (document.documentElement.style.scrollBehavior = "smooth"),
      100
    );
  };

  // 途中離脱を防止するため1つのAPIで処理をする
  const handleUpsertAccountAndSyncSF = async () => {
    try {
      await upsertAccountAndSyncSF(
        {
          SsoID__pc: user?.user_metadata.customUserId,
          Company__pc: user?.user_metadata.workPlaceInfo?.companyName,
          PersonEmail: user?.email
        },
        accountSF ?? {},
        {

          SsoID__c: user?.user_metadata.customUserId.toString(),
          LastName: user?.user_metadata.profile?.fullName?.lastName,
          FirstName: user?.user_metadata.profile?.fullName?.firstName,
          Company__pc: user?.user_metadata.workPlaceInfo?.companyName,
          PersonEmail: user?.email
        },
        accountSF ?? {},
        dataSyncCustomeSf ?? {}
      )
    } catch (error) {
      throw error;
    }
  }

  const handleFetchSetting = async () => {
    if (globalState.isSaving) return; 
    setStateValue("isSaving", true);
    try {
      const originalUser = globalState.user?.user_metadata || {};
      let dataToSave: IUserMetaDataApi = {
        ...data,
        authenticated: 1,
        user_status: 2,
      };
      dataToSave = addTimestamp(originalUser, dataToSave);
      
      const result = await fetchUpdateUserMeataData(user_id ?? "", dataToSave);
      await refreshAccessToken();
      await handleUpsertAccountAndSyncSF();
      // 不要だが、proxy apiを叩いて場合に最新情報が取れるようにキャッシュ更新用にリクエストしておく
      await fetchUserInfoProxy(1);

      if(result?.status === Http.SUCCESS_CODE) {
        setGlobalState({
          ...globalState,
          user: {
            ...globalState.user,
            user_metadata: {
              ...data,
              authenticated: 1,
              user_status: 2
            }
          }
        });
        localStorage.removeItem("userMetaDataForm");
        localStorage.removeItem("mailmagid");

        // SDK_WEB-1374: bulk-download inflow only — return to AdverTimes before /user/survey
        if (returnTo && isAdverTimesBulkDownloadFlow(returnTo)) {
          const url = new URL(returnTo);
          let sid: string | null = sessionId;
          if (
            !sid &&
            needsExternalSession(window.location.href, returnTo)
          ) {
            sid = await createExternalSession();
          }
          if (sid) {
            url.searchParams.set("session_id", sid);
          }
          attachBulkDownloadIfNeeded(url);
          localStorage.removeItem("loginCallBackUrl");
          localStorage.removeItem("surveyId");
          window.location.href = url.toString();
          return;
        }

        if (survey) {
          setIsSurvey(true);
          handleScrollToTop();
          setTimeout(() => {
            navigate(Routes.SURVEY, { state: { survey_id: survey_id} });
          }, 3000);

          return;
        } 
        else if (surveyMember){
          setIsSurvey(true);
          handleScrollToTop();
          setTimeout(() => {
            navigate(`${Routes.SURVEY_MEMBER}?web_link_id=${webLinkId}`);
          }, 3000);
          return;
        }
        
        else if(returnTo) {
          const url = new URL(returnTo);

          if (sessionId) {
            url.searchParams.set("session_id", String(sessionId));
          }
          attachBulkDownloadIfNeeded(url);

          window.location.href = url.toString();
        } else {
          if (user_status === 1 || user_status === 3) {
            navigate(
              `${Routes.USERSETTING}${serviceId ? "?serviceid=" + serviceId : ""}`,
              {
                state: { isSettingComplete: true },
              }
            );
            handleScrollToTop();

            setTimeout(() => {
              window.location.href = `${appConfig.SPA_EVENT_WEB}/marketing/`;
            }, 2000);
          } else {
            navigate(
              `${Routes.USERSETTING}${serviceId ? "?serviceid=" + serviceId : ""}`,
              {
                state: { isSettingComplete: true },
              }
            );
          }
        }
      }
    } catch (err) {
      if (!(err instanceof Error)) {
        const res = err as AxiosResponse;
        return res;
      }
    } finally {
      setStateValue("isSaving", false);
    }
  };

  return (
    <div>
      {!isSurvey && (
        <div className="row">
          <div className="col">
            <div className="page__user-setting">
              <div className="register-form js-register-form">
                <h1 className="register-form_title"> {t("common.menu.setting")}</h1>
                <div className="register-form_content">
                  <p className="register-form_text">
                    {t("features.userSetting.confirmBeforeSubmitting")}
                  </p>
                  <div className="register-form_sections">
                    <BasicInfo
                      formData={data}
                      isEdit={false}
                      isShow={selectedComponents.includes("BasicInfo")}
                      isShowPosition={selectedComponents.includes("PositionInfo")}
                    />
                    {selectedComponents.includes("BasicInterests") && (
                      <BasicInterests isEdit={false} userData={data} />
                    )}
                    {selectedComponents.includes("WorkPlace") && (
                      <>
                        <WorkPlace formData={data} isEdit={false} />
                      </>
                    )}

                    {selectedComponents.includes("HomePlace") && (
                      <>
                        <HomePlace formData={data} isEdit={false} />
                      </>
                    )}

                    {selectedComponents.includes("NewsletterSetting") && (
                      <NewsletterSetting data={data} isEdit={false} />
                    )}
                    {/* <ContactInfo formData={data} isEdit={false} /> */}
                    {/* {isFirstTimeSetting && (
                      <NewsletterSetting data={data} isEdit={false} />
                    )} */}
                    {/* {data?.interest?.occupationCode &&
                    data?.interest?.occupationCode.toString() != "5" &&
                    data?.interest?.occupationCode.toString() != "4" ? (
                      <SurveyFrom
                        userData={data}
                        isFirstTimeSetting={isFirstTimeSetting}
                        type={
                          data?.interest?.occupationCode?.toString() == "3" ? 2 : 1
                        }
                        isEdit={false}
                      />
                    ) : (
                      <></>
                    )} */}
                  </div>

                  <div className="register-form_submit-confirm">
                    <Button
                      disabled={globalState.isSaving}
                      onClick={() => {
                        navigate(
                          `${Routes.USERSETTING}${
                            serviceId ? "?serviceid=" + serviceId : ""
                          }`,
                          {
                            state: {
                              dataEdit: data,
                              isFirstTime: isFirstTimeSetting,
                              survey: survey
                            },
                          }
                        );
                        handleScrollToTop();
                      }}
                      className="register-form_back-btn"
                    >
                      {t("common.edit")}
                    </Button>
                    <Button
                      onClick={handleFetchSetting}
                      className="register-form_btn"
                    >
                      {t("common.send")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isSurvey && 
        (
          <div className="survey_page center mt20">
            <p className="mb4 text_err">ご登録ありがとうございました。</p>
            <p className="mb16 text_err">ダウンロードページへ遷移します。</p>
          </div>
        )
      }
    </div>
  );
};

export default UserSettingConfirm;
